import { OrderDetail } from 'api'
import { orderDetailIsSBL } from 'model'
import { createSelector, Selector } from '@reduxjs/toolkit'
import {
  authorisedUserIsPermissionedToTradeInstrumentSelector,
  instrumentIsEligibleForSBLSelector,
  instrumentIsPermittedToBePrimarySelector,
  instrumentCanBeTradedByAuthorisedUserSelector,
  createInstrumentCanBeTradedByTradingEntitySelector
} from './instrumentFilterSelectors'

export const createInstrumentFiltersForStagingCollateralSelector = <P>(orderDetailSelector: Selector<{}, OrderDetail, [P]>) =>
  createSelector(
    [
      orderDetailSelector,
      instrumentIsPermittedToBePrimarySelector,
      instrumentCanBeTradedByAuthorisedUserSelector,
      authorisedUserIsPermissionedToTradeInstrumentSelector,
      instrumentIsEligibleForSBLSelector,
      createInstrumentCanBeTradedByTradingEntitySelector
    ],
    (
      orderDetail,
      instrumentIsPermittedToBePrimary,
      instrumentCanBeTradedByAuthorisedUser,
      authorisedUserIsPermissionedToTradeInstrument,
      instrumentIsEligibleForSBL,
      createInstrumentCanBeTradedByTradingEntities
    ) => {
      const fundIds = orderDetail.orderFund?.id ? [orderDetail.orderFund.id] : []
      const marketType = orderDetail.order.marketType

      return [
        instrumentCanBeTradedByAuthorisedUser(marketType),
        instrumentIsPermittedToBePrimary,
        authorisedUserIsPermissionedToTradeInstrument,
        createInstrumentCanBeTradedByTradingEntities(marketType, [...fundIds, ...orderDetail.counterpartyIds]),
        ...(orderDetailIsSBL(orderDetail) ? [instrumentIsEligibleForSBL] : [])
      ]
    }
  )
